import { NavLink } from 'react-router-dom';

import { Breadcrumb, InteractiveTable, PageWrapper } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';
import { usePagination } from '~src/main/hooks/usePagination';

import { ListTable } from './list-table';

export function Page() {
  const { pageSize } = usePagination();
  const { t } = useTranslation();

  return (
    <InteractiveTable.Provider allowHighlight keepInactive>
      <PageWrapper>
        <Breadcrumb aria-label={t('common.breadcrumbs')}>
          <NavLink to="..">{t('common.settings')}</NavLink>
          <a aria-current="page">{t('common.bookingRules')}</a>
        </Breadcrumb>

        <section style={{ backgroundColor: 'inherit' }}>
          <ListTable loadRowCount={pageSize} />
        </section>
      </PageWrapper>
    </InteractiveTable.Provider>
  );
}
